<template>
  <div class="w-full relative">
    <jet-label for="timezone" value="Timezone" />
    <v-select
      data-cy="session-timezone"
      class="
        mt-1
        block
        w-full
        border-gray-300
        focus:ring-vice-teal-500
        focus:border-vice-teal-500
        rounded-md
        shadow-sm
        sm:text-sm
        text-gray-900
      "
      v-model="model"
      id="timezone"
      :options="timezones"
      :clearable="false"
      label="label"
      :reduce="(tz) => tz.value"
    >
      <template #open-indicator>
        <!-- Custom dropdown icon -->
        <span class="mr-1">
          <SelectDropdownArrow class="mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
        </span>
      </template>
    </v-select>
  </div>
</template>
<script>
import { computed } from 'vue';
import { listTz } from 'timezone-select-js';
import vSelect from 'vue-select';
import JetLabel from '@/Jetstream/Label.vue';
import 'vue-select/dist/vue-select.css';
import SelectDropdownArrow from '@/Components/Icons/SelectDropdownArrow.vue';

export default {
  name: 'TimeZoneSelect',
  components: {
    SelectDropdownArrow,
    JetLabel,
    vSelect,
  },
  emits: ['timezoneChanged'],
  props: {
    selectedTimezone: {
      required: true,
    },
  },
  setup(props, { emit }) {
    const timezones = listTz();

    const model = computed({
      get: () => props.selectedTimezone,
      set: (val) => {
        if (val) emit('timezoneChanged', val);
      },
    });

    return {
      timezones,
      model,
    };
  },
};
</script>
<style>
#timezone .vs__selected-options {
  white-space: nowrap;
  overflow-x: hidden;
  padding: 4px;
  align-content: flex-start;
  flex-wrap: nowrap;
}

#timezone .vs__selected {
  position: absolute;
}

#timezone .vs--searchable .vs__dropdown-toggle {
  height: 37px;
}

#timezone .vs__dropdown-menu {
  font-size: 13px;
}

#timezone .vs__dropdown-menu .vs__dropdown-option {
  padding-left: 1.5rem;
  white-space: normal;
  text-indent: -1rem;
}
</style>
